import {
  NationalUniversityOfSingaporeLogo,
  SduLogo,
  UclaLogo,
  UcsfLogo,
  UniversityOfMichiganLogo,
  UtokyoLogo,
} from '@jouzen/ecom-components';
import type { SVGIconComponent } from 'types/svgr';

import LandingPageIntegrations from '@/app/components/LandingPage/LandingPageIntegrations';

const ScienceAndResearchUniversities = (): JSX.Element => {
  return (
    <section className="py-20" data-cy="science-and-research-universities">
      <LandingPageIntegrations
        integrations={[
          {
            description: 'science_and_research_universities_one',
            name: 'University of California, San Francisco',
            Logo: UcsfLogo as SVGIconComponent,
          },
          {
            description: 'science_and_research_universities_three',
            name: 'University of California, Los Angeles',
            Logo: UclaLogo as SVGIconComponent,
          },
          {
            description: 'science_and_research_universities_five',
            name: 'University of Tokyo',
            Logo: UtokyoLogo as SVGIconComponent,
          },
          {
            description: 'science_and_research_universities_two',
            name: 'National University of Singapore',
            Logo: NationalUniversityOfSingaporeLogo as SVGIconComponent,
          },
          {
            description: 'science_and_research_universities_four',
            name: 'University of Michigan',
            Logo: UniversityOfMichiganLogo as SVGIconComponent,
          },
          {
            description: 'science_and_research_universities_six',
            name: 'SDU',
            Logo: SduLogo as SVGIconComponent,
          },
        ]}
      />
    </section>
  );
};

export default ScienceAndResearchUniversities;
